// Auth API client. Email/password signup and password reset now run through petzify-backend
// (https://api.petzify.in) so the OTP is generated and checked server-side — the browser only
// ever sees the code the user types in. Successful OTP verification returns a short-lived
// verificationToken which the follow-up call (signup / reset-password) must present.

const API_BASE = process.env.REACT_APP_API_BASE_URL || 'https://api.petzify.in';

async function post(path, body) {
  const res = await fetch(`${API_BASE}${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });

  let data = null;
  try {
    data = await res.json();
  } catch (_) {
    // non-JSON response
  }

  if (!res.ok) {
    const error = new Error((data && data.error) || 'Something went wrong. Please try again.');
    error.status = res.status;
    // Surfaced so the UI can show an accurate resend countdown.
    error.waitSecs = data && data.waitSecs;
    throw error;
  }

  return data || {};
}

/** purpose: 'signup' (address must be free) | 'reset' (account must exist) */
export const sendEmailOtp = (email, purpose) =>
  post('/api/auth/email/send-otp', { email: email.trim().toLowerCase(), purpose });

export const resendEmailOtp = (email, purpose) =>
  post('/api/auth/email/resend-otp', { email: email.trim().toLowerCase(), purpose });

/** Resolves to { verified, verificationToken } */
export const verifyEmailOtp = (email, otp, purpose) =>
  post('/api/auth/email/verify-otp', { email: email.trim().toLowerCase(), otp, purpose });

/** Requires a verificationToken from a 'reset' OTP. */
export const resetPassword = (verificationToken, password) =>
  post('/api/auth/reset-password', { verificationToken, password });

/** Requires a verificationToken from a 'signup' (email) or phone OTP. */
export const signupRequest = ({ name, email, phone, password, verificationToken }) =>
  post('/api/auth/signup', {
    name: name.trim(),
    email: email.trim().toLowerCase(),
    phone: phone.trim(),
    password,
    verificationToken,
  });

export const loginRequest = (email, password) =>
  post('/api/auth/login', { email: email.trim().toLowerCase(), password });
